// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "platform-host/" + chunkId + "-" + {2313: "a666aebd94e35723",2470: "9ba0fdf65642c890",25: "609af0bf725f25ef",5947: "a65961fbd4b5f0c1",}[chunkId] + ".css"
}